import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


import { compose } from 'redux';

class CreditContent extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
        window.history.back();
    }


    render() {
        let {
            twitter_url, 
            instagram_url, 
            linkedin_url, 
            contact_number, 
            contact_email, 
            copyright, 
            vat, 
            company_reg_no, 
            office_address,
            logo_image
        } = this.props.options.options;
        let {ml_videos, ml_photographies} = this.props.posts.data;;
        return (
            <section className="mole__credits--content">
                <div className="main-container">
                    <div className="inner-container">
                        <h6 className="font-lg-head c-white">Credits</h6>

                        <div className="grid">
                            <div className="grid-item">
                                <h5 className="gridspan-2">Photography</h5>
                                {
                                    ml_photographies && ml_photographies.map((item, key) => {
                                        return (
                                            <div>
                                                {
                                                    item.acf.artist && item.acf.artist.map((single, index) => {
                                                        return (<p><a href={single.link != '' ? single.link : 'javascript:void(0)'} target="_blank">{single.name}</a></p>)
                                                    })
                                                }
                                                {
                                                    item.acf.projects && item.acf.projects.map((project, index) => {
                                                        return (<p>{project.project.post_title}</p>)
                                                    })
                                                }
                                                
                                            </div>
                                        )
                                    })
                                }
                                

                                
                            </div>


                            <div className="grid-item">
                                <h5 className="gridspan-2">Video</h5>
                                {
                                    ml_videos && ml_videos.map((item, key) => {
                                        return (
                                            <div>
                                                {
                                                    item.acf.artist && item.acf.artist.map((single, index) => {
                                                        return (<p><a href={single.link != '' ? single.link : 'javascript:void(0)'} target="_blank">{single.name}</a></p>)
                                                    })
                                                }
                                                {
                                                    item.acf.projects && item.acf.projects.map((project, index) => {
                                                        return (<p>{project.project.post_title}</p>)
                                                    })
                                                }
                                                
                                            </div>
                                        )
                                    })
                                }
                            </div>


                            <div className="grid-item">
                                <h5 className="gridspan-2">Website</h5>
                                <p><a href="http://tm-studio.co.uk/" target="_blank">TM</a></p>
                            </div>

                            <div className="grid-item">
                                <h5 className="gridspan-2">Copyright</h5>
                                <article className="gridspan-2"  dangerouslySetInnerHTML={{__html:copyright}} />
                            </div>
                        </div>
                    
                        <a href="javascript:" className="link btn_prev c-hvr-white" onClick={this.handleClick}>Back</a>
                    </div>
                </div>
            </section>
        );
    }
}
export default CreditContent;



// WEBPACK FOOTER //
// ./src/components/Credits/CreditContent.js